/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import ToolkitBanner from '@moms/Banner/ToolkitBanner';
import RegisterStickyButton from '@moms/Buttons/RegisterStickyButton';
import SectionCommonUi from '@moms/Common/SectionCommonUi';
import StyleConfig from '@moms/Common/StyleConfig';
import Collaboration from '@moms/Ui/Sections/Collaboration';
import { GlobalAuthority } from '@moms/Ui/Sections/GlobalAuthority';
import { LandingVoice } from '@moms/Ui/Sections/LandingVoice';
import MakingMiracle from '@moms/Ui/Sections/MakingMiracle';
import { MiracleInAction } from '@moms/Ui/Sections/MiracleInAction';
import NotEnough from '@moms/Ui/Sections/NotEnough';
import OtherMovements from '@moms/Ui/Sections/OtherMovements';
import OwnYourDay from '@moms/Ui/Sections/OwnYourDay';
import PeopleBenifitted from '@moms/Ui/Sections/PeopleBenifitted';
import SeeMircale from '@moms/Ui/Sections/SeeMircale';
import ShareWhatsapp from '@moms/Ui/Sections/ShareWhatsapp';
import ShowScience from '@moms/Ui/Sections/ShowScience';
import SilentUnderCurrent from '@moms/Ui/Sections/SilentUnderCurrent';
import StudiesDone from '@moms/Ui/Sections/StudiesDone';
import UnitedForWellBeing from '@moms/Ui/Sections/UnitedForWellBeing';
import WhatSetsMomApart from '@moms/Ui/Sections/WhatSetsMomApart';
import HowItWorks from '@moms/Ui/Sections/HowItWorks';
import Rewards from '@moms/Ui/Sections/Rewards';
import InnerPowerLeague from '@moms/Ui/Sections/InnerPowerLeague';

/* Styles */
/* Services */

/**
 *
 * @param {Object} section
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const RenderSections = ({ section, region, lang }) => {
  // show-science
  const { sectionId } = section;
  if (sectionId === 'silent-undercurrent') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <SilentUnderCurrent
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'register-sticky-button') {
    return (
      <RegisterStickyButton
        sectionContent={section.sectionContent}
        region={region}
        language={lang}
      />
    );
  } else if (sectionId === 'show-science') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <ShowScience
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'global-authority') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <GlobalAuthority
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'making-a-miracle') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <MakingMiracle
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'what-sets-mom-apart') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <WhatSetsMomApart
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'leading-voices') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <LandingVoice
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  }
  //  else if (sectionId === 'proven-by') {
  //   return (
  //     <StyleConfig
  //       id={section?.sectionId}
  //       key={section.sectionId}
  //       style={section?.styleConfig}
  //       section={section}
  //     >
  //       <ProvenBy
  //         sectionContent={section.sectionContent}
  //         region={region}
  //         lang={lang}
  //       />
  //     </StyleConfig>
  //   );
  // }
  else if (sectionId === 'studies-done') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <StudiesDone
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'collaborations') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <Collaboration
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'see-miracle') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <SeeMircale
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'own-your-day') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <OwnYourDay
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'united-for-wellbeing') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <UnitedForWellBeing
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'people-benefitted') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <PeopleBenifitted
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  }  else if (sectionId === 'how-it-works') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <HowItWorks
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'rewards') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <Rewards
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'share-whatapp') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <ShareWhatsapp
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'other-movements') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <OtherMovements
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'not-enough') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <NotEnough
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'miracle-in-action') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <MiracleInAction
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  }  else if (sectionId === 'inner-power-league') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <InnerPowerLeague
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'toolkit-banner') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <ToolkitBanner
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'toolkit-section') {
    return (
      <StyleConfig
        id={section?.sectionId}
        key={section.sectionId}
        style={section?.styleConfig}
        section={section}
      >
        <></>
        {/* <ToolkitSection
          sectionContent={section.sectionContent}
          region={region}
          lang={lang}
        /> */}
      </StyleConfig>
    );
  } else {
    return (
      <Box as="div" display="block" placeContent="center">
        <StyleConfig
          id={section?.sectionId}
          key={section.sectionId}
          style={section?.styleConfig}
          section={section}
        >
          {section?.sectionContent?.length > 0
            ? section?.sectionContent?.map((secCon, i) => {
                return (
                  <SectionCommonUi
                    key={i}
                    sectionContent={secCon}
                    section={section}
                    region={region}
                    lang={lang}
                  />
                );
              })
            : null}
        </StyleConfig>
      </Box>
    );
  }
};
export default RenderSections;
